@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@full-spacing-px: 24px;
@half-spacing-px: calc(@full-spacing-px / 2);
@row-gap: 8px;

.basic-hotkeys {
  margin-right: @full-spacing-px;
}

.body {
  display: flex;
  padding: @full-spacing-px;
}

.checkbox-slider {
  padding: 2px 0 0 5px;
}

.hotkeys-section {
  display: grid;
  grid-template-columns: auto 2fr;
  gap: @row-gap @full-spacing-px;
  padding: @half-spacing-px @full-spacing-px @half-spacing-px 0;
  grid-auto-rows: min-content;
  font-size: 14px;

  .section-title {
    font-weight: @bold;
    grid-column: 1 / span 2;
    padding-bottom: calc(@full-spacing-px - @row-gap);

    &:not(:first-child) {
      padding-top: calc(@full-spacing-px - @row-gap);
    }
  }
}

.icon {
  height: 15px;
  width: 15px;
}

.keyname {
  font-weight: @bold;
  font-family: 'Courier New', monospace;
  font-size: 12px;

  .key-separator {
    font-family: 'Courier New', monospace;
    padding: 0 5px;
    opacity: 0.5;
  }
}

.title {
  border-bottom: 1px solid @hotkeys-modal--title--border-color;
  display: flex;
  justify-content: space-between;
  padding-bottom: @half-spacing-px;

  h3 {
    padding: 0;
    margin: 0;
  }
}

.advanced-hotkeys-section {
  .advanced-hotkey-columns {
    display: flex;
    flex-direction: row;
  }
}

.disabled {
  .advanced-hotkey-columns,
  .toggle-label {
    opacity: 0.5;
  }
}
